/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CommentThreadNotificationActionData
 */
export interface CommentThreadNotificationActionData {
    /**
     * 
     * @type {string}
     * @memberof CommentThreadNotificationActionData
     */
    type: CommentThreadNotificationActionDataTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof CommentThreadNotificationActionData
     */
    entityId: string;
    /**
     * 
     * @type {string}
     * @memberof CommentThreadNotificationActionData
     */
    entityUserId: string;
    /**
     * 
     * @type {string}
     * @memberof CommentThreadNotificationActionData
     */
    commentUserId: string;
    /**
     * 
     * @type {string}
     * @memberof CommentThreadNotificationActionData
     */
    commentId?: string;
}


/**
 * @export
 */
export const CommentThreadNotificationActionDataTypeEnum = {
    Track: 'Track',
    Playlist: 'Playlist',
    Album: 'Album'
} as const;
export type CommentThreadNotificationActionDataTypeEnum = typeof CommentThreadNotificationActionDataTypeEnum[keyof typeof CommentThreadNotificationActionDataTypeEnum];


/**
 * Check if a given object implements the CommentThreadNotificationActionData interface.
 */
export function instanceOfCommentThreadNotificationActionData(value: object): value is CommentThreadNotificationActionData {
    let isInstance = true;
    isInstance = isInstance && "type" in value && value["type"] !== undefined;
    isInstance = isInstance && "entityId" in value && value["entityId"] !== undefined;
    isInstance = isInstance && "entityUserId" in value && value["entityUserId"] !== undefined;
    isInstance = isInstance && "commentUserId" in value && value["commentUserId"] !== undefined;

    return isInstance;
}

export function CommentThreadNotificationActionDataFromJSON(json: any): CommentThreadNotificationActionData {
    return CommentThreadNotificationActionDataFromJSONTyped(json, false);
}

export function CommentThreadNotificationActionDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): CommentThreadNotificationActionData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'type': json['type'],
        'entityId': json['entity_id'],
        'entityUserId': json['entity_user_id'],
        'commentUserId': json['comment_user_id'],
        'commentId': !exists(json, 'comment_id') ? undefined : json['comment_id'],
    };
}

export function CommentThreadNotificationActionDataToJSON(value?: CommentThreadNotificationActionData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'type': value.type,
        'entity_id': value.entityId,
        'entity_user_id': value.entityUserId,
        'comment_user_id': value.commentUserId,
        'comment_id': value.commentId,
    };
}

